import { z } from 'zod'
import { oc } from '@orpc/contract'
import { pageSchema } from '../../utils/page.contract'
import { recordQuerySchema } from '../../utils/record-query.contract'
import { CPG_XWALK_KIND_VALUES, cpgXwalkRuleSchema } from './cpg-registry.contract'

/** Filterable/sortable columns of the xwalk rules table. */
export const CPG_XWALK_QUERY_FIELDS = [
  'id',
  'familySlug',
  'kind',
  'system',
  'code',
  'updatedAt',
  'updatedBy',
] as const

/** `familyId` narrows to one family (the Families view's rules section). */
export const listCpgXwalkRules = oc
  .route({ method: 'POST', path: '/v2/cpg/xwalk/list' })
  .input(
    recordQuerySchema(CPG_XWALK_QUERY_FIELDS).extend({
      familyId: z.number().int().positive().optional(),
    }),
  )
  .output(z.object({ page: pageSchema, data: z.array(cpgXwalkRuleSchema) }))

/**
 * Every rule matches its code plus the code's subtree (docs/db/DB_SCHEMA_CPG.md). Duplicate
 * (family, kind, system, code) → CONFLICT. Writes a cpg_registry_audit row.
 */
export const createCpgXwalkRule = oc
  .route({ method: 'POST', path: '/v2/cpg/xwalk' })
  .input(
    z.object({
      familyId: z.number().int().positive(),
      kind: z.enum(CPG_XWALK_KIND_VALUES),
      system: z.string().min(1),
      code: z.string().min(1),
    }),
  )
  .output(z.object({ data: cpgXwalkRuleSchema }))

export const deleteCpgXwalkRule = oc
  .route({ method: 'DELETE', path: '/v2/cpg/xwalk/{id}' })
  .input(z.object({ id: z.coerce.number().int().positive() }))
  .output(z.object({ id: z.number() }))
